import React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <ContentWrapper>
      <Div className='content-padding'>
        <Div className='mt-2'>
          <Div className='mask-title'>
            <Div className='dis-flex-center'>
              <Div className='mt-2'>
                <Typography fontSize={24} fontWeight={600} color={"white"}>Page Not Found</Typography>
              </Div>
            </Div>
          </Div>
        </Div>
        <Div className='dis-flex-center mt-2'>
          <Div className='p-4'>
            <Typography fontSize={20} fontWeight={600}>404</Typography>
          </Div>
        </Div>

        <Div className='flex-justify-center' sx={{ mt: 2 }}>
          <ButtonStyled
            onClick={() => navigate('/')}
            btnText={"Home"}
            sx={{ maxWidth: '451px' }}
          />
        </Div>


      </Div>
    </ContentWrapper>

  );
};

export default PageNotFound;